{
  "nav": {
    "heading": "Admin",
    "users": "Users",
    "auditLog": "Audit log",
    "backToApp": "Back to site",
    "outbox": "Event queue",
    "reports": "Moderation",
    "stats": "Statistics",
    "flags": "Feature flags"
  },
  "users": {
    "heading": "Users",
    "search": "Search",
    "searchPlaceholder": "Name or email address",
    "filterStatus": "Status",
    "filterRole": "Role",
    "any": "All",
    "empty": "No account matches these criteria.",
    "loading": "Loading accounts…",
    "columns": {
      "user": "User",
      "status": "Status",
      "roles": "Roles",
      "createdAt": "Signed up",
      "lastLogin": "Last sign-in"
    },
    "never": "Never",
    "deletionPending": "Deletion scheduled"
  },
  "status": {
    "pending": "Pending",
    "active": "Active",
    "suspended": "Suspended",
    "deactivated": "Deactivated"
  },
  "detail": {
    "heading": "User details",
    "back": "Back to list",
    "identity": "Identity",
    "roles": "Roles",
    "activity": "Administrative history",
    "noActivity": "No administrative action on this account.",
    "loading": "Loading details…",
    "emailVerified": "Email verified",
    "emailUnverified": "Email not verified",
    "grantRole": "Grant",
    "revokeRole": "Revoke",
    "rolePlaceholder": "Choose a role",
    "profile": "Profile",
    "profileEmpty": "This account has filled in nothing.",
    "headline": "Headline",
    "bio": "Bio",
    "subjects": "Subjects",
    "languages": "Languages",
    "website": "Personal website",
    "profileVerified": "Profile verified",
    "profileUnverified": "Profile not verified",
    "preferences": "Preferences and consents",
    "preferencesHelp": "Read-only: a consent collected by someone else is not a consent.",
    "shareProgress": "Progress shared with teachers",
    "marketingEmails": "Marketing emails",
    "theme": "Theme",
    "granted": "Granted",
    "refused": "Declined",
    "deletionScheduled": "This account will be anonymised on {{date}}, at its owner's request.",
    "deletionRequestedAt": "Request received on {{date}}. The owner can still change their mind until the deadline."
  },
  "actions": {
    "suspend": "Suspend",
    "reactivate": "Reactivate",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "reason": "Reason",
    "reasonHelp": "Required, at least 10 characters. It will be kept in the audit log.",
    "suspendTitle": "Suspend this account",
    "suspendWarning": "The user will no longer be able to sign in, and open sessions will be closed.",
    "reactivateTitle": "Reactivate this account",
    "reactivateWarning": "The user will be able to sign in again. Previous sessions stay closed.",
    "grantRoleTitle": "Grant a role",
    "revokeRoleTitle": "Revoke a role",
    "roleWarning": "This change takes effect at the user's next sign-in, and will be recorded in the audit log."
  },
  "audit": {
    "heading": "Audit log",
    "description": "Every administrative action is recorded here. The log cannot be edited or erased.",
    "empty": "No entries.",
    "loading": "Loading the log…",
    "filterAction": "Action",
    "columns": {
      "date": "Date",
      "action": "Action",
      "actor": "Actor",
      "target": "Target",
      "reason": "Reason"
    },
    "system": "System",
    "noReason": "—"
  },
  "actionNames": {
    "user.suspended": "Account suspended",
    "user.reactivated": "Account reactivated",
    "user.role_granted": "Role granted",
    "user.role_revoked": "Role revoked"
  },
  "errors": {
    "cannotTargetSelf": "You cannot perform this action on your own account.",
    "reasonTooShort": "The reason must be at least 10 characters long."
  },
  "outbox": {
    "heading": "Event queue",
    "description": "What has not been published yet, and why. Oldest first — that is what blocks the queue.",
    "empty": "The queue is empty — everything has been published.",
    "deadLetters": "{{deadValue}} event(s) have exhausted their attempts and will not resume on their own.",
    "deadLetter": "Abandoned",
    "attempts": "{{attemptsValue}} attempt(s)",
    "nextAttempt": "Next attempt: {{when}}",
    "replay": "Replay",
    "confirmReplay": "Confirm replay",
    "cancel": "Cancel",
    "reasonLabel": "Replay reason",
    "reasonPlaceholder": "Why replay this event?",
    "views": {
      "unpublished": "Everything left",
      "pending": "Pending",
      "failed": "Failed"
    }
  },
  "reports": {
    "heading": "Moderation",
    "description": "Reported content, oldest first. Opening content is written to the audit log.",
    "openOnly": "Open cases only",
    "empty": "Nothing to review.",
    "noDetails": "The reporter did not add any detail.",
    "status": "Status: {{statusValue}}",
    "alsoReported": "reported {{countValue}} times",
    "disclose": "View the content",
    "discloseAudited": "This access will be written to the audit log, with your name and the time.",
    "windowGone": "The 72-hour window has elapsed: the content can no longer be opened.",
    "itemDeleted": "Deleted by its author — kept for moderation.",
    "itemHidden": "Already removed by moderation.",
    "decision": "Decision",
    "note": "Reason for the decision",
    "notePlaceholder": "What you found, and why you are deciding this way.",
    "submit": "Decide",
    "alreadyHandled": "This report has already been handled. Reason: {{noteValue}}",
    "actions": {
      "reject": "Reject",
      "warn": "Warn",
      "hide": "Hide",
      "suspend": "Suspend"
    },
    "reasons": {
      "spam": "Spam",
      "harassment": "Harassment",
      "inappropriate": "Inappropriate content",
      "other": "Other"
    },
    "statuses": {
      "open": "open",
      "reviewing": "under review",
      "resolved": "handled",
      "rejected": "rejected"
    },
    "entities": {
      "messaging.message": "Private message"
    }
  },
  "stats": {
    "title": "Statistics",
    "subtitle": "The state of the platform, computed on read. No ratio is calculated server-side: the figures are raw.",
    "accounts": "Accounts",
    "accountsDetail": "{{active}} active · {{suspended}} suspended",
    "courses": "Published courses",
    "coursesDetail": "{{drafts}} drafts",
    "enrollments": "Enrolments",
    "enrollmentsDetail": "{{completed}} completed",
    "certificates": "Certificates issued",
    "certificatesDetail": "{{revoked}} revoked",
    "mrr": "Monthly revenue",
    "mrrDetail": "{{subscribers}} active subscriptions",
    "storage": "Storage",
    "storageDetail": "{{files}} files",
    "gigabytes": "{{value}} GB",
    "unpriced": "{{count}} active subscription(s) have no price attached: the revenue shown ignores them.",
    "growth": "Growth",
    "window": "Observation window",
    "days": "{{count}} days",
    "chartLabel": "{{series}}, day by day over {{days}} days",
    "point": "{{day}}: {{count}}",
    "series": {
      "signups": "Account signups",
      "coursesPublished": "Courses published",
      "enrollments": "Course enrolments",
      "completions": "Courses completed"
    }
  },
  "flags": {
    "title": "Feature flags",
    "subtitle": "The switches behind each feature. Turning one off takes effect immediately, platform-wide, and is written to the audit log.",
    "noDescription": "No description: this flag does not say what it guards.",
    "open": "On",
    "closed": "Off",
    "open_action": "Turn on",
    "close": "Turn off",
    "cancel": "Cancel",
    "confirmClose": "Turn off platform-wide?",
    "updatedAt": "changed on {{at}}"
  }
}
